/** SVG grid map with station markers. Coordinates use 0..1 space. */
import { useNavigate } from "react-router-dom";

export default function StationMap({ stations, selectedId, onSelect, emergency = false, height = 480 }) {
  const navigate = useNavigate();
  const W = 800;
  const H = height;

  const handleClick = (s) => {
    if (onSelect) onSelect(s);
    else navigate(`/app/consumer/stations/${s.id}`);
  };

  return (
    <div data-testid="station-map" className="bin-map" style={{ height: H }}>
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full">
        {/* compass */}
        <g opacity="0.4">
          <text x="20" y="24" fill="#52525B" fontSize="10" fontFamily="IBM Plex Mono">N</text>
          <text x={W - 30} y={H - 12} fill="#52525B" fontSize="10" fontFamily="IBM Plex Mono">{`${W}×${H}`}</text>
        </g>

        {/* connecting energy ring (decorative) */}
        <circle cx={W / 2} cy={H / 2} r={Math.min(W, H) / 3} fill="none" stroke="#27272A" strokeDasharray="2 8" />

        {stations.map((s) => {
          const cx = s.x * W;
          const cy = s.y * H;
          const color =
            s.status === "online" ? "#4ADE80" :
            s.status === "maintenance" ? "#FFA800" : "#71717A";
          const isSel = selectedId === s.id;
          return (
            <g
              key={s.id}
              data-testid={`map-station-${s.id}`}
              onClick={() => handleClick(s)}
              style={{ cursor: "pointer" }}
            >
              {emergency && s.status === "online" && (
                <circle cx={cx} cy={cy} r="22" fill="none" stroke="#FF3838" strokeOpacity="0.6">
                  <animate attributeName="r" from="12" to="30" dur="1.4s" repeatCount="indefinite" />
                  <animate attributeName="stroke-opacity" from="0.7" to="0" dur="1.4s" repeatCount="indefinite" />
                </circle>
              )}
              {s.status === "online" && (
                <circle cx={cx} cy={cy} r="14" fill={color} opacity="0.18">
                  <animate attributeName="r" from="8" to="20" dur="2s" repeatCount="indefinite" />
                  <animate attributeName="opacity" from="0.25" to="0" dur="2s" repeatCount="indefinite" />
                </circle>
              )}
              <circle cx={cx} cy={cy} r={isSel ? 8 : 5} fill={color} stroke={isSel ? "#00E5FF" : "transparent"} strokeWidth="2" />
              <text
                x={cx + 10} y={cy + 4}
                fill={isSel ? "#fff" : "#A1A1AA"}
                fontSize="10"
                fontFamily="IBM Plex Mono"
              >
                {s.name}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
